var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"app"},[_c('Header'),_c('Hero'),_c('DecorationItem'),_c('Countdown'),_c('Info'),_c('Footer'),_c('NewsletterForm'),_c('Griddle')],1)}
var staticRenderFns = []

export { render, staticRenderFns }